import { isEmpty } from 'lodash-es';

import { ValueLeftAxis } from '../../../core/components/axes/components/ValueLeftAxis.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { AREAS } from '../../constants/histogram-grid-area-rules.js';
import { useHistogramTickAxis } from '../../hooks/useHistogramTickAxis.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';
import { useYAxisConfig } from '../../hooks/useYAxisConfig.js';

export const HistogramValueLeftAxisArea = () => {
  const { left: axisLeft } = useYAxisConfig();
  const ticks = useHistogramTickAxis();

  const [yScale] = useHistogramYScales();
  const leftTicks = ticks?.left || { ticks: [], formattedTicks: [] };

  if (isEmpty(leftTicks.ticks) || !yScale) {
    return null;
  }

  return (
    <ChartGrid.GridArea gridArea={AREAS.leftAxis}>
      {({ availableWidth, availableHeight }) => {
        return (
          <ValueLeftAxis
            ticks={leftTicks.ticks}
            formattedTicks={leftTicks.formattedTicks}
            containerHeight={availableHeight}
            containerWidth={availableWidth}
            scale={yScale}
            label={axisLeft?.label}
          />
        );
      }}
    </ChartGrid.GridArea>
  );
};

HistogramValueLeftAxisArea['displayName'] = 'HistogramValueLeftAxisArea';
